import styled from "@emotion/styled";
import { Dialog } from "@mui/material";

export const OnePointDialog = styled(Dialog)`
	.MuiPaper-root {
		border-radius: 18px;
	}

	.MuiDialogTitle-root {
		background-color: var(--primary);
		color: white;

		.helptext {
			font-size: 15px;
			font-style: normal;
			font-weight: 700;
		}

		.title {
			font-size: 30px;
			font-style: normal;
			font-weight: 700;
		}

		.title-box {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			.helptext {
				font-size: 15px;
				font-style: normal;
				font-weight: 700;
			}

			.title {
				font-size: 30px;
				font-style: normal;
				font-weight: 700;
			}

			.icon {
				width: 60px;
				height: 60px;

				.logo {
					width: 100%;
				}
			}
		}
	}

	.button-group {
		display: flex;
		flex-direction: row;
		gap: 10px;
		flex-wrap: wrap;
	}

	.description {
		font-size: 20px;
		font-weight: bold;
		margin-top: 20px;
	}

	.blue {
		color: var(--primary);
	}

	.description-mini {
		font-size: 16px;
		padding-left: 20px;
	}
	.description-help {
		font-size: 16px;
	}

	@media screen and (max-width: 600px) {
		.MuiDialogTitle-root {
			.title-box {
				.title {
					font-size: 26px;
				}

				.icon {
					width: 40px;
					height: 40px;

					.logo {
						width: 100%;
					}
				}
			}
		}
	}
`;
